/**
 * Build the entity-detail-page path for a WeaponeeringSearchResult returned
 * by GlobalTargetFinderModal (the /api/weaponeering/search response model).
 *
 * That response model names the identifier field `entity_id`, not `id` --
 * reading `entity.id` was always undefined and sent every search-result
 * click to `/weaponeering/{type}/undefined`.
 *
 * Pluralization is irregular for 'facility' -> 'facilities'; every other
 * entity_type ('site', 'dmpi') just gets a trailing 's'.
 */
export function buildWeaponeeringEntityPath(entity) {
  const pluralType = entity.entity_type === 'facility' ? 'facilities' : `${entity.entity_type}s`;
  return `/weaponeering/${pluralType}/${entity.entity_id}`;
}

export default buildWeaponeeringEntityPath;
